import React  from 'react';
import { useConnect } from '@lore/query-connect';

export default function Invitations(props) {
  const { user } = props;

  const pending = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          userId: user.id,
          response: 'Pending'
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const declined = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          userId: user.id,
          response: 'No'
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const maybe = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          userId: user.id,
          response: 'Maybe'
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const attending = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          userId: user.id,
          response: 'Yes'
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  return (
    <div className="whitespace-nowrap space-x-2">
      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
        {declined.meta ? declined.meta.totalCount : '...'}
      </span>
      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
        {pending.meta ? pending.meta.totalCount : '...'}
      </span>
      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
        {maybe.meta ? maybe.meta.totalCount : '...'}
      </span>
      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
        {attending.meta ? attending.meta.totalCount : '...'}
      </span>
    </div>
  );
}
